import { StrategySafe, ConditionalStrategySafe } from 'utility-ts-strategy';
import * as _4 from 'lodash4';

export interface IRegistrationWaitlistOutcomeStatus {
  name: string;
}

export enum OUTCOME_STATUS_TYPES {
  REGISTRATION_REQUEST_REGISTERED = 'REGISTRATION_REQUEST_REGISTERED',
  REGISTRATION_REQUEST_WAITLISTED = 'REGISTRATION_REQUEST_WAITLISTED',
  WAITLIST_REQUEST_REGISTERED = 'WAITLIST_REQUEST_REGISTERED',
  WAITLIST_REQUEST_WAITLISTED = 'WAITLIST_REQUEST_WAITLISTED',
  REGISTRATION_REQUEST_FAILED = 'REGISTRATION_REQUEST_FAILED',
  WAITLIST_REQUEST_FAILED = 'WAITLIST_REQUEST_FAILED'
}

export type registration_waitlist_outcome_status_type =
  | OUTCOME_STATUS_TYPES.REGISTRATION_REQUEST_REGISTERED
  | OUTCOME_STATUS_TYPES.REGISTRATION_REQUEST_WAITLISTED
  | OUTCOME_STATUS_TYPES.WAITLIST_REQUEST_REGISTERED
  | OUTCOME_STATUS_TYPES.WAITLIST_REQUEST_WAITLISTED
  | OUTCOME_STATUS_TYPES.REGISTRATION_REQUEST_FAILED
  | OUTCOME_STATUS_TYPES.WAITLIST_REQUEST_FAILED;

export const RegistrationWaitlistOutcomeStatusStrategy = new StrategySafe<
  IRegistrationWaitlistOutcomeStatus,
  registration_waitlist_outcome_status_type
>({
  REGISTRATION_REQUEST_REGISTERED: {
    name: OUTCOME_STATUS_TYPES.REGISTRATION_REQUEST_REGISTERED
  },
  REGISTRATION_REQUEST_WAITLISTED: {
    name: OUTCOME_STATUS_TYPES.REGISTRATION_REQUEST_WAITLISTED
  },
  WAITLIST_REQUEST_REGISTERED: {
    name: OUTCOME_STATUS_TYPES.WAITLIST_REQUEST_REGISTERED
  },
  WAITLIST_REQUEST_WAITLISTED: {
    name: OUTCOME_STATUS_TYPES.WAITLIST_REQUEST_WAITLISTED
  },
  REGISTRATION_REQUEST_FAILED: {
    name: OUTCOME_STATUS_TYPES.REGISTRATION_REQUEST_FAILED
  },
  WAITLIST_REQUEST_FAILED: {
    name: OUTCOME_STATUS_TYPES.WAITLIST_REQUEST_FAILED
  }
});

export interface IRegistrationWaitlistOutcomeStatusContext {
  id: number;
  request_type: string;
  message: string;
  success: boolean;
  is_registered: boolean;
  is_waitlisted: boolean;
}

export const RegistrationWaitlistOutcomeStatusConditionalStrategy = new ConditionalStrategySafe<
  IRegistrationWaitlistOutcomeStatusContext,
  registration_waitlist_outcome_status_type
>({
  REGISTRATION_REQUEST_REGISTERED: (context: IRegistrationWaitlistOutcomeStatusContext) =>
    context.request_type === 'ADD' && context.success && context.is_registered && !context.is_waitlisted,
  REGISTRATION_REQUEST_WAITLISTED: (context: IRegistrationWaitlistOutcomeStatusContext) =>
    context.request_type === 'ADD' && context.success && !context.is_registered && context.is_waitlisted,
  REGISTRATION_REQUEST_FAILED: (context: IRegistrationWaitlistOutcomeStatusContext) =>
    context.request_type === 'ADD' && !context.success,
  WAITLIST_REQUEST_WAITLISTED: (context: IRegistrationWaitlistOutcomeStatusContext) =>
    context.request_type === 'WAITLIST' && context.success && !context.is_registered && context.is_waitlisted,
  WAITLIST_REQUEST_REGISTERED: (context: IRegistrationWaitlistOutcomeStatusContext) =>
    context.request_type === 'WAITLIST' && context.success && context.is_registered && !context.is_waitlisted,
  WAITLIST_REQUEST_FAILED: (context: IRegistrationWaitlistOutcomeStatusContext) =>
    context.request_type === 'WAITLIST' && !context.success
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/strategies/registration_waitlist_outcome_status_strategy.ts